<template>
  <!-- div class="login-page-wrapper" :class="{'bodyfont-unauth': !user}" -->
      <!-- iframe style="width:100%;height:100vh;" src="https://anchor.fm/mia910/episodes/test-e156chp"></iframe -->
      <iframe title="TONE podcast" style="width:100%;height:100vh;" src="https://www.podpage.com/have-you-had-this-conversation/"></iframe>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import jwplayer from './JwPlayer.vue'
//    import $ from 'jquery'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            'jwplayer': jwplayer
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'Podcast'
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                giftPlans: '',
                spinner: false,
                videoURL: window.location.href,
                currentPlayerID: '',
                currentPlayerID2: '',
                sharingTitle: 'TONE Networks, Set the Tone of Your Life',
                sharingDescription: '',
                dynamic_para_1: '',
                dynamic_para_2: '',
                dynamic_para_3: '',
                dynamic_para_4: '',
                dynamic_para_5: '',
                dynamic_para_6: '',
                dynamic_para_7: '',
                dynamic_bullet_1: '',
                dynamic_bullet_2: '',
                dynamic_bullet_3: '',
                dynamic_button_1: '',
                dynamic_promotion_img: ''
            }
        }
    }
</script>
<style>
    /*.socialicons i{*/
        /*margin-right:30px;*/
    /*}*/
    /*@media(max-width:767px) {*/
        /*.socialicons i {*/
            /*color: #333;*/
        /*}*/
    /*}*/
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .socialicons {
        color: #f0617d;
        letter-spacing: 10px;
    }
    @media(max-width:767px) {
        .socialicons {
            color: #f0617d;
            margin: 20px 0 0;
        }
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .aboutlogoholder {
        min-height: 300px;
        line-height: 300px;
    }

    .mtop30 {
        margin-top: 30px;
    }

    .row.aboutrow p {
        font-size: 17px;
        text-align: left;
        line-height: 1.3;
        letter-spacing: 2px;
    }
    h3 {
        color: #f0617d;
        letter-spacing: 4px;
        font-size: 24px;
        line-height: 1.5;
        margin: 30px 0 20px;
    }
    h4 {
        color: #454545;
        letter-spacing: 2px;
        font-size: 18px;
        text-align: left;
        line-height: 1.5;
		font-weight:700;
    }
    h4.welcomemessage {
        text-align: center;
        margin: 50px 0 0;
        color: inherit;
        color: #f0617d;
    }

    h2.welcomemessage {
        letter-spacing: 8px;
        margin: 20px 0 60px;
        text-transform: uppercase;
    }
    .slide-player img {
        max-width: 100%;
    }
    @media(max-width:480px){
        body h4 {
            font-size: 18px !important;
        }

        h3 {
            font-size: 24px !important;
            line-height: 1.1 !important;
        }

        h2.welcomemessage {
            letter-spacing: 3px !important;
        }
    }
.over-lay {
    /*background-image: url(https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg);background-repeat: no-repeat;*/
    // background-image: url(../assets/mothersday-image-desktop.jpg);background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    width: 100%;
    display: inline-block;
    padding: 50px 0 50px;
}
.over-lay .main-heading p {
    margin-top: 15px;
    font-size: 20px;
    line-height: 31px;
    font-family: "Quicksand", sans-serif;
}
.over-lay ul {
    margin: 30px 0 0;
    padding: 0;
}

.over-lay ul {
    font-size: 27px;
    font-weight: 500;
    line-height: 1.2;
}

.over-lay ul li {
    list-style: none;
    margin: 0 0 0px;
}
    .main-heading .btn {
        margin: 30px 0;
        font-size: 24px;
    }
.showMobile{display:block;}
@media(min-width:768px){
    .showMobile{display:none;}

.over-lay h1 {
    color: #fff;
	clear:both;
}

.over-lay ul li:nth-child(1) {
    clear: left;
    float: left;
    margin-right: 10px;
}
    .over-lay .container {
        max-width: 95%;
        width: 100%;
    }
}

    .over-lay:before {
        z-index:5;
        background-image:url(../assets/whiteribbon.png);
        /*content:"";*/
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: cover !important;
        background-position: left top !important;
    }
.over-lay {
    position: relative;
}

.over-lay .container {
    position: relative;
    z-index: 10;
	color:#fff;
}
ul.tonepoints {
    font-size: 18px;
    letter-spacing: 2px;
}

ul.tonepoints li {
    margin: 0 0 20px;
}
@media (max-width:767px){
    .over-lay.text-left {
        background-image: none;
        padding: 20px 0;
        color: #333 !important;
    }
    .main-heading .btn {
        margin: 10px 0 30px;
        font-size: 24px;
    }
    .over-lay:before , .over-lay:after {
        display: none;
    }

    .over-lay h1 {
        color: #343434;
    }

    .over-lay .main-heading p {
        color: #343434;
    }

    .over-lay ul li {
        color: #343434;
    }

}

    .row.aboutrow {
        padding-bottom: 50px;
    }
/*gift section classes*/
.gift-item:before {
    background: url(../assets/img_33997.png);
	content:"";
    height: 150px;
    display: block;
    /* width: 100%; */
    position: absolute;
    background-position: center !important;
    background-repeat: no-repeat !important;
    transform: translateY(-50%);
    /* margin: 120px 0 0; */
    /* top: -30px; */
    top: 0;
    right: 0;
    left: 0;
}

.gift-item {
    background: #54d9ec;
    color: #fff;
    margin: 120px 0 0;
    padding: 80px 20px 20px;
    position: relative;
    text-align: center;
}

    @media(min-width:768px){

    }
    @media(max-width:767px){
        .vedioplayerholder {
            margin-top: 20px;
        }
    }

    /*social icons settings*/


    @media(min-width:768px){
        .socialicons {
            position: absolute;
            right: 30px;
            width: 20px;
            top:calc(100% + 70px);
        }

        .over-lay .col-sm-5 {
            position: static;
        }

        .socialicons > span, .socialicons > button {
            margin: 0 0 20px;
            display: block;
        }



    }
    @media(min-width:992px){
        .socialicons {
            top: calc(100% + 70px);
        }
    }
    @media(min-width:1200px){
        .socialicons {
            top: calc(100% + 70px);
        }
    }
    @media(max-width:767px){
        .hideMobile {
            display: none;
        }
        .over-lay ul{
            font-size:22px;
        }
    }
    @media(min-width:768px) {
        .over-lay ul, .over-lay H1 {
            text-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
        }
    }
</style>
<style>
    .socialicons  > .holder .fa {
        color: #fff;
        line-height: 42px;
        width: 42px;
        text-align: center;
        display: block;
        letter-spacing: 0;
    }

    .socialicons  > .holder {
        background: #f0617d;
        width: 42px;
        display: inline-block;
        height: 42px;
        line-height: 42px;
        border-radius: 50%;
    }
    .socialicons > a img {
        max-width: 42px;
    }
    @media(min-width:768px){
        .socialicons  > .holder {
            margin: 0 0 20px;
            display:block;
        }
        .over-lay .row {
            min-height: 450px;
        }
    }
</style>



// WEBPACK FOOTER //
// PodcastTone.vue?53e98024